/* eslint arrow-body-style: 0 */
// Estúdio Social. A rota default do módulo (`/social`) aponta pro calendário
// editorial (Task 12) — tela principal do módulo; Contas continua acessível
// em /social/accounts (link a partir do editor quando não há rede
// conectada, e do próprio calendário).
import { frontendURL } from '../../../helper/URLHelper';
import SocialAccountsPage from '../../../components-next/social/SocialAccountsPage.vue';
import SocialCalendarPage from '../../../components-next/social/SocialCalendarPage.vue';
import SocialMetricsPage from '../../../components-next/social/SocialMetricsPage.vue';
import SocialProductionPage from '../../../components-next/social/SocialProductionPage.vue';
import SocialFeedPage from '../../../components-next/social/SocialFeedPage.vue';

// Index é liberado a qualquer agente (SocialAccountPolicy#index?/SocialPost
// via `authorize(SocialPost)` — mesma regra, sem predicate específico de
// index); conectar/desconectar rede e aprovar/publicar posts são restritos a
// administrador dentro dos próprios componentes (mesma regra que o backend
// aplica em connect_url?/destroy?/approve/publish).
const SOCIAL_PERMISSIONS = ['administrator', 'agent', 'custom_role'];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/social'),
      redirect: to => ({
        name: 'social_calendar_index',
        params: to.params,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/social/calendar'),
      name: 'social_calendar_index',
      meta: {
        permissions: SOCIAL_PERMISSIONS,
      },
      component: SocialCalendarPage,
    },
    {
      path: frontendURL('accounts/:accountId/social/accounts'),
      name: 'social_accounts_index',
      meta: {
        permissions: SOCIAL_PERMISSIONS,
      },
      component: SocialAccountsPage,
    },
    {
      path: frontendURL('accounts/:accountId/social/metrics'),
      name: 'social_metrics_index',
      meta: {
        permissions: SOCIAL_PERMISSIONS,
      },
      component: SocialMetricsPage,
    },
    {
      path: frontendURL('accounts/:accountId/social/production'),
      name: 'social_production_index',
      meta: {
        permissions: SOCIAL_PERMISSIONS,
      },
      component: SocialProductionPage,
    },
    {
      path: frontendURL('accounts/:accountId/social/feed'),
      name: 'social_feed_index',
      meta: {
        permissions: SOCIAL_PERMISSIONS,
      },
      component: SocialFeedPage,
    },
  ],
};
